import { useCallback, useMemo } from 'react';

import { useGraphql } from '../graphql';
import { useLoad } from '../load';
import { recordFields } from '../records';

// One of the clinician's patients and their daily records from `from` to
// `to`, in one request: what the patient's Diary tab draws under its header.
// data is undefined until the answer for this very range arrives or when it
// failed, so another month never shows the previous one's days; error and
// retry are useLoad's.
export function usePatientDiary({ patientId, from, to }) {
  const graphql = useGraphql();

  const read = useCallback(function() {
    return graphql({
      document: `query PatientDiary($id: ID!, $from: String!, $to: String!) {
        patient(id: $id) { id firstName lastName connectedSince }
        patientDailyRecords(patientId: $id, from: $from, to: $to) { ${ recordFields } }
      }`,
      variables: { id: patientId, from, to }
    });
  }, [ graphql, patientId, from, to ]);

  const { data, error, retry } = useLoad(read);

  return useMemo(function() {
    return { data, error, retry };
  }, [ data, error, retry ]);
}
